<template>
    <div class="regLogMain">
      <div class="pwd-cont">
        <div class="pwd-item1">
          <span class="pwd-num pwd-hover col-blue" style="line-height:32px;"><em v-if="stepsIndex==1 || stepsIndex==2 || stepsIndex==3" class="arrow-ri"></em>Authenticate</span>
          <span class="pwd-num" :class="stepsIndex==4 || stepsIndex==5 ? 'pwd-hover col-blue' :'' "><em v-if="stepsIndex==4" class="arrow-ri"></em>Set a new<br>password</span>
          <span class="pwd-num" :class="stepsIndex==5 ? 'pwd-hover col-blue' :'' " style="line-height:32px;"><em v-if="stepsIndex==5" class="arrow-ri"></em>Re-setComplete</span>
        </div>

        <!--忘记密码第一步 start-->
        <ul class="pwd-item2" v-if="stepsIndex==1">
          <li>
            <h4>Email</h4>
            <p><input class="reg-email" v-model="Email" placeholder="Email Address" :class="IsEmail ? 'borColRed' : ''" @blur="CheckEmail()" type="text"></p>
            <p class="msgTips" v-if="IsEmail">{{EmailMsg}}</p>
          </li>
          <li>
            <h4>Code</h4>
            <p>
              <input class="reg-email2" placeholder="Verification Code" v-model="Verification" @blur="IsVerification()" :class="IsVerificationCode ? 'borColRed' : ''" type="text" />
              <label class="l"><img :src="databaes64" width="100" height="42" @click="VerificationCode()" /></label>
            </p>
            <p class="msgTips" v-if="IsVerificationCode">{{VerificationCodeMsg}}</p>
          </li>
          <li><input class="but but04" value="Next Step" type="button" @click="FSendMail()"></li>
          <li><a href="/reg/login" >Back to sign in</a></li>
        </ul>
        <!--忘记密码第一步 end-->

        <!--忘记密码第二步 start-->
        <ul class="pwd-item2 spcPwd" v-if="stepsIndex==2">
          <li>
            <!--<h4>Activate your Freightshop account</h4>-->
            <p>Verify that the message has been sent to your mailbox: <b>{{Email}}</b></p>
            <p class="marTop10">Verify that the email is valid within 2 hours. Please log in your email, click the reset password link in the email, and set up a new password.</p>
            <p class="marTop20">
               <label class="l" style="line-height:40px;"> Haven't received the mail? </label>
               <label class="l marL30"> <input class="but but01 transformMin" value="Resend" :class='[!this.canClick ? "disabled" : "tranRes"]' type="button" @click="FSendMail()" /></label>
            </p>
            <div style="clear:both"></div>
            <p v-show="!this.canClick" style="text-align:right;margin-left: -45px;"> Try again in<span class="colRed">{{this.totalTime}}</span> seconds</p>
          </li>
        </ul>
        <!--忘记密码第二步 end-->

        <!--忘记密码第三步 start-->
        <ul class="pwd-item2 spcPwd2" v-if="stepsIndex==3">
          <li>
            <p><img style="margin:30px auto" src="../../../assets/img/iconEm3.png" width="80"/> </p>
            <h4>Your verification email link has expired. </h4>
            <p>Please re-acquire your verification email.</p>
            <p class="marTop20">
              <label class="marL30"><input class="but but01" style="margin:auto" @click="FSendMail()" value="Resend" type="button" :class='[!this.canClick ? "disabled" : "tranRes"]' /></label>
              <span v-show="!this.canClick">
                Try again in
                <span class="colRed">{{this.totalTime}}</span> seconds
              </span>
            </p>
          </li>
        </ul>
        <!--忘记密码第三步 end-->

        <!--忘记密码-设置密码 Set a new password start-->
        <ul class="pwd-item2" v-if="stepsIndex==4">
          <li>
            <h4>Password</h4>
            <p><input class="reg-email" placeholder="New Password" v-model="Password" type="Password" @blur="CheckPassword()" :class="IsPassword ? 'borColRed' : ''" ></p>
             <p class="msgTips" v-if="IsPassword">{{PasswordMsg}}</p>
          </li>
          <li>
            <h4>Confirm Password</h4>
            <p><input class="reg-email" placeholder="Confirm New Password" v-model="Password2" type="Password" @blur="CheckPassword2()" :class="IsPassword2 ? 'borColRed' : ''"></p>
             <p class="msgTips" v-if="IsPassword2">{{PasswordMsg}}</p>
          </li>
          <li><input class="but but04" value="CONFIRM" type="button" @click="ResetPassword()" ></li>
 
        </ul>
        <!--忘记密码-设置密码 end-->

        <!--忘记密码-设置成功 start-->
        <ul class="pwd-item2 spcPwd2" v-if="stepsIndex==5">
          <li>
            <p><img style="margin:30px auto" src="../../../assets/img/iconEm4.png" width="84"/> </p>
            <h4>Your password has been reset successfully.  </h4>
            <p>Please remember your new password!</p>
            <p class="marTop20">
              <label class="marL30"><input class="but but01" style="margin:auto" @click="Login()" value="Login Immediately" type="button" /></label>
            </p>
          </li>
        </ul>
        <!--忘记密码-设置成功 end-->
      </div>
    </div>
</template>

<script type="text/ecmascript-6">
//按钮防抖
import {_debounce} from "@/ask/util";
import { post, fetch, Del, put } from "../../../ask/axios";
  export default {
    components:{},

    data (){
      return {
         api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
        //判断当前是第几步 1:第一步；2：第二步；3：第三步;4：第四步;5：第五步
        stepsIndex:1,
        //邮箱
        Email:'',
        IsEmail:false,
        EmailMsg:'Please enter your email',
         //验证码
       // Verification:'',
        databaes64:'',
        dataKey:'',
        Verification:'',
        VerCode:'', //复制存值，用于修改密码不成功的时候，再次发送邮件
        ValidateCode:'',
        IsVerificationCode:false,
        VerificationCodeMsg:'',
        Password:'',
        Password2:'',
        IsPassword:'',
        IsPassword2:'',
        PasswordMsg:'',

        ResContent: "Resend",
        totalTimeStart: 120,
        totalTime: 120,
        canClick: true //添加canClick
      }
    },
    created(){
        if(this.$route.query.Email&&this.$route.query.Vcode&&this.$route.query.Key&&this.$route.query.SendTime){
      //alert('004')
       this.CheckMail();
    }else{
     
    }
     
    },
     mounted(){ //dom已经生成
       this.VerificationCode();    
  },
    methods:{
       countDown() {
        if (!this.canClick) return; 
        this.canClick = false;
        this.ResContent = this.totalTime
        let clock = window.setInterval(() => {
          this.totalTime--;
          this.ResContent = this.totalTime
          if (this.totalTime < 0) {
            window.clearInterval(clock);
            this.ResContent = "";
            this.totalTime = 120;
            this.canClick = true; //这里重新开启
          }
          
        }, 1000);
      },
      //用来防抖，在一定时间内只会放送一次请求
      FSendMail: _debounce(function(_type, index, item) {
			  this.SendMail();
		  }, 1000),



      //邮箱点击事件验证
   CheckEmail(){
    var regEmail= /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    if(this.Email==null||this.Email==''){
      this.IsEmail=true;
      this.EmailMsg='Working email is required'
    }else{
      if(!regEmail.test(this.Email)){ //只能输入邮箱格式
      this.Email = '';
      this.IsEmail=true;
      this.EmailMsg='Please enter a valid email address'
     }else{
        this.IsEmail=false;
        return this.EmailId
     }
    }
   },

    Login(){
      window.location.href ="/reg/Login"
     },
    //验证码接口
    VerificationCode(){
      let that = this;
      that.api.param={}
      // that.api.url=this.$api02+"/api/EbayCustomer/ImageCode/CreateImage";
      that.api.url=this.$api04 + "/Basics/api/ImageCode/CreateImage";
      fetch(that.api.url,that.api.param).then(function(res){
          if(res.IsOK){
            that.databaes64=res.Results.Data
            that.dataKey=res.Results.CheckCodeKey
            that.ValidateCode=res.Results.ValidateCode
          }
      })
    }, //判断是否输入验证码
    IsVerification(){
      //this.VerCode=JSON.stringify(JSON.parse(this.Verification))
      if(this.Verification==null||this.Verification=='')
      {
        this.IsVerificationCode=true;
        this.VerificationCodeMsg='Please enter the verification code';
        return false;
      }else
      {
        this.IsVerificationApi();
      }
    },
     //验证验证码
     IsVerificationApi(){
      let that = this;
      that.api.param={
        checkCodeKey:that.dataKey,
        validateCode:that.Verification
      }
      that.api.url=this.$api02+"/api/EbayCustomer/ImageCode/GetCheckCodeIF";
      fetch(that.api.url,that.api.param).then(function(res){
        if(res.Results==true){
            that.VerificationCodeMsg=res.Message;
            that.IsVerificationCode=false;
            return true;
         }else{
          that.VerificationCodeMsg="Validation code error or expired";
          that.IsVerificationCode=true;
         }

    })
    },
    SendMail(){
       let that = this;
      if(this.stepsIndex!==1){
        this.countDown()
      } 
      //如果是第一步，就不执行倒计时
      if(this.totalTime < this.totalTimeStart ){
          return
           false
        }

        //
        if(this.stepsIndex==3){
          //console.log('that.VerCode  ' +  that.VerCode)
          that.Email=that.$route.query.Email
          that.Verification=that.ValidateCode
        }
     
       that.api.param={
         email:that.Email,
         checkCodeKey:that.dataKey,
         validateCode:that.Verification
      }

      that.api.url=this.$api02+"/api/EbayCustomer/NewAccountInfo/ForgetPasswordSendEmail";
      fetch(that.api.url,that.api.param).then(function(res){
        if(res.ErrorCode=='C0001'){
           that.stepsIndex=2;
         }else if(res.ErrorCode=='CE019'){
           that.IsEmail=true;
           that.EmailMsg='This email address is not registered'
         }else if(that.stepsIndex==3){
           that.stepsIndex=3
         }
    })
    },
    CheckMail(){
      let that = this;
       that.api.param={
        email:this.$route.query.Email,
        checkCodeKey :this.$route.query.Key,
        validateCode:this.$route.query.Vcode
      }
      that.api.url=this.$api02+"/api/EbayCustomer/NewAccountInfo/ForgetPasswordCheckEmail";
      fetch(that.api.url,that.api.param).then(function(res){
        if(res.ErrorCode=='C0001'){
             that.stepsIndex=4;
         }
         else{
            that.stepsIndex=3;
         }
    })
    },
    //验证密码
    CheckPassword(){
     //var reg=/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
     var reg = /^.{6,20}$/;
     if(this.Password==null||this.Password==''){
      this.IsPassword=true;
      this.PasswordMsg='Password is required'
     }else{
     this.IsPassword=false;
     this.PasswordMsg=''
     if(!reg.test(this.Password)){ //只能输入邮箱格式
      this.Password = '';
      this.IsPassword=true;
      this.PasswordMsg='Please enter 6-20 characters using alphanumeric, numeric or symbolic.'
     }else{
      this.IsPassword=false;
      this.PasswordMsg=''
      return this.Password
     }
     }

    },

    //验证密码格式
     CheckPassword2(){
      if(this.Password2==null||this.Password2==''){
          this.IsPassword2=true;
          this.PasswordMsg='Password is required'
      }else{
          this.IsPassword2=false;
          this.PasswordMsg=''
       if(this.Password!=this.Password2){ //只能输入邮箱格式
          this.Password2 = '';
          this.IsPassword2=true;
          this.PasswordMsg='The two password do no match'
      }else{
          this.IsPassword2=false;
          this.PasswordMsg=''
          return this.Password2
      }
      }
    },
    ResetPassword(){
      if(!this.Password || !this.Password2){
        return false
      }
       let that = this;
        that.api.param={
         "Email": this.$route.query.Email,
         "SendTime": this.$route.query.SendTime,
         "Key": this.$route.query.Key,
         "Vcode": this.$route.query.Vcode,
        "NewPassword": that.Password
      }
      that.api.url=this.$api02+"/api/EbayCustomer/CustomerInfoPwd/ResetLogInPwd";
      post(that.api.url,that.api.param).then(function(res){
        if(res.ErrorCode=='C0001'){
             that.stepsIndex=5;
          }
         else{
            that.stepsIndex=3;
         }
      })
      
      },
    }
    }
</script>
<style lang="less" scoped="scoped">
 @import "../../../assets/css/regLog.less";
 .byTerms h3{font-size:16px;text-align:center;margin:10px 0 20px 0;}
 .byTerms p{line-height:22px;font-size:12px;}
 .byTerms h4{line-height:26px;font-size:13px;}
 .disabled {
	background-color: #ddd !important;
	border-color: #ddd;
	color: #57a3f3;
	cursor: not-allowed;
  transform:scale(1)
}
.tranRes:active{
  transform:scale(0.97)
}
</style>



// WEBPACK FOOTER //
// src/components/reception/reg/findPwd.vue